module.exports = __webpack_public_path__ + "img/notification2.77e60953.svg";